const requiredText = "Required";
const yesValue = "Yes";

const validateRequired = value => !value && requiredText;

const validateFemaleEmpQuestions = (values, errors) => {
  if (values.Gender === "Female") {
    if (!values.EmpPapSmear) {
      errors.EmpPapSmear = requiredText;
    }

    if (!values.EmpGynaecological) {
      errors.EmpGynaecological = requiredText;
    }

    if (!values.EmpMenstruationDisorder) {
      errors.EmpMenstruationDisorder = requiredText;
    }

    if (!values.EmpBreastCancer) {
      errors.EmpBreastCancer = requiredText;
    }

    if (!values.EmpPregnant) {
      errors.EmpPregnant = requiredText;
    }
  }
};

const validateForm = values => {
  const errors = {};

  validateFemaleEmpQuestions(values, errors);

  if (
    values.EmpAdventure === yesValue ||
    values.EmpDrugAddiction === yesValue ||
    values.EmpExclusions === yesValue ||
    values.EmpWeightLoss === yesValue ||
    values.EmpSmoke === yesValue ||
    values.EmpLungDisorder === yesValue ||
    values.EmpMentalDisorders === yesValue ||
    values.EmpBowelDisorder === yesValue ||
    values.EmpKidneyDisorder === yesValue ||
    values.EmpBloodDisorder === yesValue ||
    values.EmpHearingAndSight === yesValue ||
    values.EmpGallbladderDisorder === yesValue ||
    values.EmpPhysicalInjury === yesValue ||
    values.EmpHeartDisorder === yesValue ||
    values.EmpSexualDisease === yesValue ||
    values.EmpDiagnosisInfo === yesValue ||
    values.EmpPhysicalDisability === yesValue ||
    values.EmpFamilyHistory === yesValue ||
    values.EmpPapSmear === yesValue ||
    values.EmpGynaecological === yesValue ||
    values.EmpMenstruationDisorder === yesValue ||
    values.EmpBreastCancer === yesValue ||
    values.EmpPregnant === yesValue
  ) {
    if (!values.MoreInfoSubQNo1) {
      errors.MoreInfoSubQNo1 = requiredText;
    }

    if (!values.MoreInfoName1) {
      errors.MoreInfoName1 = requiredText;
    }

    if (!values.MoreInfoDiagnosis1) {
      errors.MoreInfoDiagnosis1 = requiredText;
    }

    if (!values.MoreInfoDiagnosisDate1) {
      errors.MoreInfoDiagnosisDate1 = requiredText;
    }

    if (!values.MoreInfoIllnessDuration1) {
      errors.MoreInfoIllnessDuration1 = requiredText;
    }

    if (!values.MoreInfoReason1) {
      errors.MoreInfoReason1 = requiredText;
    }

    if (!values.MoreInfoMedicalProvider1) {
      errors.MoreInfoMedicalProvider1 = requiredText;
    }
  }

  if (values.EmpSmoke === yesValue) {
    if (!values.EmpSmokeQuantity) {
      errors.EmpSmokeQuantity = requiredText;
    }
  }

  if (values.EmpFamilyHistory === yesValue) {
    if (!values.FamilyRelationship1) {
      errors.FamilyRelationship1 = requiredText;
    }

    if (!values.FamilyMedicalCondition1) {
      errors.FamilyMedicalCondition1 = requiredText;
    }

    if (!values.FamilyAgeAtDiagnosis1) {
      errors.FamilyAgeAtDiagnosis1 = requiredText;
    }

    if (!values.FamilyAgeAtDeath1) {
      errors.FamilyAgeAtDeath1 = requiredText;
    }
  }

  if (values.EmpBreastCancer === yesValue) {
    if (!values.EmpBreastCancerFamilyRelation1) {
      errors.EmpBreastCancerFamilyRelation1 = requiredText;
    }

    if (!values.EmpBreastCancerFamilyAgeDiagnosed1) {
      errors.EmpBreastCancerFamilyAgeDiagnosed1 = requiredText;
    }

    if (!values.EmpBreastCancerFamilyBreastDetails1) {
      errors.EmpBreastCancerFamilyBreastDetails1 = requiredText;
    }
  }

  if (values.EmpPregnant === yesValue) {
    if (!values.EmpPregnantDurationValue) {
      errors.EmpPregnantDurationValue = requiredText;
    }
  }

  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Prudential/validation.js